import { LinearProgress } from '@material-ui/core';
import { ColorDynamic } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import { CheckCircleIcon } from 'shared/icons/CheckCircleIcon';
import styled from 'styled-components';

const StyledLinearProgress = styled(LinearProgress)`
  & {
    height: 8px;
    border-radius: 4px;
  }

  .MuiLinearProgress-barColorPrimary {
    background-color: ${ColorDynamic.Blue300};
    border-radius: 4px;
  }

  &.MuiLinearProgress-colorPrimary {
    background-color: ${ColorDynamic.Silver400};
  }
`;

interface ViewLoadVehicleInspectionSyncSummaryProps {
  synced: number;
  total: number;
}

export function ViewLoadVehicleInspectionSyncSummary({
  synced,
  total,
}: ViewLoadVehicleInspectionSyncSummaryProps) {
  const progress = total > 0 ? Math.round((synced / total) * 100) : 0;

  if (synced === total && total > 0) {
    return (
      <Box display="flex" alignItems="center">
        <Box marginRight="xxsmall">
          <CheckCircleIcon fontSize="small" color="action" />
        </Box>
        <TextBox variant="hint" color="secondary" noWrap={true}>
          Inspection synced
        </TextBox>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center">
      <Box minWidth="100px" marginRight="xsmall">
        <StyledLinearProgress
          color="primary"
          variant="determinate"
          value={progress}
        />
      </Box>
      <TextBox variant="hint" noWrap={true}>
        {`${synced} of ${total} photos synced`}
      </TextBox>
    </Box>
  );
}
